// src/redux/modules/auth/services/tokenService.ts
import { STORAGE_KEYS } from '@/rtkQuery/config/apiConfig';
import type { TokenPayload, TokenSet } from '../../models/auth.model';

class TokenService {
    getAccessToken(): string | null {
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    }

    getRefreshToken(): string | null {
        return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    }

    setTokens({ accessToken, refreshToken }: TokenSet): void {
        if (accessToken) {
            localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
        }
        if (refreshToken) {
            localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
        }
    }

    clearTokens(): void {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    }

    hasValidTokens(): boolean {
        return !!(this.getAccessToken() && this.getRefreshToken());
    }

    decodeToken(token: string): TokenPayload | null {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );

            return JSON.parse(jsonPayload);
        } catch (err) {
            console.error('Invalid JWT:', err);
            return null;
        }
    }

    isTokenExpired(token: string | null): boolean {
        if (!token) return true;
        const decoded = this.decodeToken(token);
        if (!decoded?.exp) return true;
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp < currentTime;
    }

    isAccessTokenExpired(): boolean {
        return this.isTokenExpired(this.getAccessToken());
    }
}

export const tokenService = new TokenService();
